import { render } from "./ActiveItem.vue?vue&type=template&id=f59f59c4&scoped=true"
import script from "./ActiveItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveItem.vue?vue&type=script&setup=true&lang=js"

import "./ActiveItem.vue?vue&type=style&index=0&id=f59f59c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59f59c4"],['__file',"src/components/Event/ActiveItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f59f59c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f59f59c4', __exports__)) {
    api.reload('f59f59c4', __exports__)
  }
  
  module.hot.accept("./ActiveItem.vue?vue&type=template&id=f59f59c4&scoped=true", () => {
    api.rerender('f59f59c4', render)
  })

}


export default __exports__